export default __webpack_public_path__ + "static/assets/857d7298041194367b9ae1ba271624e2.gif";